/* global showAlert */
import SubmitController from './submit_controller';

class AddToCartController extends SubmitController {
  static targets = ['quantity', 'form'];

  handleClick(event) {
    const target = event.currentTarget;
    const quantity = this.quantityTarget.value;

    if (quantity) {
      const qtty = Number(quantity);
      if (!qtty || qtty <= 0) {
        showAlert({ message: 'Por favor ingrese una cantidad válida' });
        return;
      }

      const { method, url } = this.getSettings({ qtty });

      target.dataset.method = method;
      target.dataset.url = url;

      super.handleClick(event);
    } else {
      showAlert({ message: 'Por favor ingrese una cantidad' });
    }
  }

  getSettings({ qtty }) {
    const form = this.formTarget;

    return {
      method: form.method,
      url: `${form.action}&cart_item[quantity]=${qtty}`,
    };
  }
}

export default AddToCartController;
